import { observer } from "mobx-react";
import emailCustomizationStore from "../../stores/email-customization-store";
import "./logo-upload.scss";
import { FormFieldLine } from "../../../../components/form-field-line/form-field-line";
import FileUpload from "../../../../components/file-upload/file-upload";
import IconImageRequest from "../../../../components/icons/icon-image-request/icon-image-request";
import FontHeading5 from "../../../../components/fonts/font-heading5/font-heading5";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import config from "../../../../config";

const LogoUpload: React.FC = observer(() => {
    const uploadLogo = (fileData: File, fileContent: string) => {
        if (fileData && fileContent) {
            emailCustomizationStore.uploadLogo(fileData.type, fileContent.split(',')[1]);
        }
    }
    return <div className="logo-upload-container">
        <FontHeading5 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
            Upload Your Logo
        </FontHeading5>
        <FontHeading5>
            By default, we present your store name as text in emails. you can choose to upload a logo that appears in all emails your customer recieves
        </FontHeading5>
        <FormFieldLine
            label='Logo'
            note='Image size up to 2MB. Accepted formats: .jpg .jpeg .png .gif. The recommended maximum width is 570px.'
        >
            <div className="logo-upload-input">
                <div className="upload-icon-container">
                    <IconImageRequest color="var(--color-semantic-3)" />
                </div>
                <FileUpload
                    uploadFile={(fileData, fileContant) => uploadLogo(fileData, fileContant as string)}
                    buttonText={"Upload image"}
                    readType="dataUrl"
                    fileTypes={["image/jpeg", "image/png", "image/gif"]}
                    acceptedFileFormats=".jpg,.jpeg,.png,.gif"
                    disabled={emailCustomizationStore.isLoading || emailCustomizationStore.isSaving()}
                    maxFileSize={config.emailLogoMaxSize}
                />
            </div>
        </FormFieldLine>
    </div>
});

export default LogoUpload;
